<template>
  <div
    class="project-structure-tree-taktplan font-weight-light"
    :style="`width: calc(${project_length + 4} * (var(--workpackage_width) + 8px) * var(--taktplan_zoom))`"
    >
    <div
      :class="`project-structure-tree-taktplan-parent grey darken-${parent_color_index >= 3?3:parent_color_index} ${!open || child_elements.length === 0?'project-structure-tree-taktplan-parent-closed': 'project-structure-tree-taktplan-parent-open'}`"
      @click="$emit('parentClicked', parent)"
      :style="`
        left: calc(${sticky_left}px * var(--taktplan_zoom));
        width: ${!open || child_elements.length === 0?`calc((var(--project_taktplan_spatial_header_width) * 1px - ${sticky_left}px) * var(--taktplan_zoom))`:'calc(25px * var(--taktplan_zoom))'};
        border-color: var(--header_border_color) !important;
        `"
      >
      <div style="position: absolute; overflow: hidden; height: 100%; white-space: nowrap;">{{parent.name}}{{parent.type === 'element_wrapper'?`s (${child_elements.length})`:''}} {{child_elements.length === 0?'(no elements)':''}}</div>
    </div>
    <div
      v-if="open && child_elements.length !== 0"
      class="project-structure-tree-taktplan-children"
      >
      <template v-for="item in child_elements">
        <div
          v-if="item.type === 'elements'"
          :key="`elements${item.id}`"
          style="display: flex;"
          >
        <div
          class="project-structure-tree-taktplan-element"
          :style="`left: calc(${sticky_left + 25}px * var(--taktplan_zoom)); width: calc((var(--project_taktplan_spatial_header_width) * 1px - 25px - ${sticky_left}px) * var(--taktplan_zoom))`"
          >
          {{item.name}}
        </div>
        <div
          class="project-structure-tree-taktplan-taktarea-wrapper"
          :style="`width: calc((${project_length + 1} * (var(--workpackage_width) + 8px) + var(--project_taktplan_ta_header_width) * 1px) * var(--taktplan_zoom))`"
          >
          <div
            v-if="getElementTaktareas({project_id: project_id, id: item.id}).length === 0"
            class="project-structure-tree-taktplan-taktarea"
            >
            <HeaderPlaceholder
              width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
              height="calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom))"
              z_index="2"
              :sticky_left="`calc((var(--project_taktplan_spatial_header_width) * 1px) * var(--taktplan_zoom))`"
              :background_color="'var(--v-color-1-base)'"
              />
          </div>
          <template v-else>
            <v-hover
              v-for="taktarea in getElementTaktareas({project_id: project_id, id: item.id})"
              :key="`taktarea${taktarea.id}`"
              >
              <template #default="hover_takarea">
                <div class="project-structure-tree-taktplan-taktarea">
                  <HeaderRow
                    z_index="2"
                    sticky_left="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
                    width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
                    border_color="#424242"
                    border_width="0px 0px 0px 0px"
                    inner_border="solid 1px rgba(255,255,255,0.8)"
                    :text="taktarea.name"
                    :readonly="true"
                  />
                  <Placeholder
                    :key="`placeholder_taktareastart_${taktarea.id}`"
                    :count="taktarea.taktarea_start + taktarea.train.train_start"
                    >
                  </Placeholder>
                  <draggable
                    class="display-flex"
                    :key="`taktarewaggons${taktarea.id}`"
                    animation="300"
                    forceFallback="true"
                    fallbackOnBody="true"
                    :disabled="!hover_takarea.hover ||
                               !isEditMode ||
                               $route.name !=='ProjectTaktPlan'?
                               true:false"
                    :value="taktarea.twaggons"
                    @update="requestSnackbarUpdatePosition({
                        url: [
                          {projects: project_id},
                          {trains: taktarea.train.id},
                          {taktareas: taktarea.id},
                          {twaggons: taktarea.twaggons[$event.oldIndex]},
                        ],
                        update: {
                          position: $event.newIndex - $event.oldIndex,
                          position_twaggons: taktarea.twaggons
                        }
                      }).then((payload) => {
                        updateUObjectPosition(payload)
                    })"
                    >
                    <v-hover
                      v-for="(waggon, waggon_index) in getUObjects({type: 'twaggons', ids: taktarea.twaggons})"
                      :key="`waggonhoveractivtor${waggon.id}`"
                      >
                      <template #default="{hover}">
                        <Waggon
                          :key="`waggon${waggon.id}`"
                          :workpackage_count="waggon.tworkpackages.length"
                          :easter_egg="false"
                          >
                          <!-- :easter_egg="waggon.tworkpackages[0] % 10 === 0 && hover" -->
                          <template #prepend
                            v-if="hover && isEditMode"
                            >
                            <Activator
                              :key="`waggonactivatorprepend${waggon.id}`"
                              v-if="$route.name === 'ProjectTaktPlan'"
                              class="self-centered cursor-cell"
                              @click.native="requestSnackbarCreate({
                                url: [
                                  {projects: project_id},
                                  {trains: taktarea.train.id},
                                  {taktareas: taktarea.id},
                                  {twaggons: ''},
                                  {showWithEntitiesNormalized: ''}
                                ],
                                u_object: {
                                  position: waggon_index + parseInt(1)
                                },
                                reference: {
                                  before: true,
                                  type: 'twaggons',
                                  id: waggon.id
                                }
                              }).then((payload) => {
                                createUObject(payload)
                              })"
                            />
                            <Activator
                              :key="`waggonactivatorprepend${waggon.id}`"
                              v-if="$route.name === 'TaktPlanWorkPackageEdit' && waggon.tworkpackages.includes(parseInt($route.params.tworkpackage_id))"
                              class="self-centered cursor-cell"
                              @click.native="requestSnackbarCreate({
                                url: [
                                  {projects: project_id},
                                  {trains: taktarea.train.id},
                                  {taktareas: taktarea.id},
                                  {twaggons: waggon.id},
                                  {extendwp: ''},
                                  {showWithEntitiesNormalized: ''}
                                ],
                                u_object: {
                                  waggon_payload: {position: waggon_index + parseInt(1)},
                                  twp_id: $route.params.tworkpackage_id
                                },
                                reference: {
                                  before: true,
                                  type: 'twaggons',
                                  id: waggon.id
                                }
                              }).then((payload) => {
                                createUObject(payload)
                              })"
                            />
                          </template>
                          <template #append
                            v-if="hover && isEditMode"
                            >
                            <Activator
                              :key="`waggonactivatorappend${waggon.id}`"
                              class="self-centered cursor-cell"
                              v-if="$route.name === 'ProjectTaktPlan'"
                              @click.native="requestSnackbarCreate({
                                url: [
                                  {projects: project_id},
                                  {trains: taktarea.train.id},
                                  {taktareas: taktarea.id},
                                  {twaggons: ''},
                                  {showWithEntitiesNormalized: ''}
                                ],
                                u_object: {
                                  position: waggon_index + parseInt(2)
                                },
                                reference: {
                                  before: false,
                                  type: 'twaggons',
                                  id: waggon.id
                                }
                              }).then((payload) => {
                                createUObject(payload)
                              })"
                            />
                            <Activator
                              :key="`waggonactivatorappend${waggon.id}`"
                              class="self-centered cursor-cell"
                              v-if="$route.name === 'TaktPlanWorkPackageEdit' && waggon.tworkpackages.includes(parseInt($route.params.tworkpackage_id))"
                              @click.native="requestSnackbarCreate({
                                url: [
                                  {projects: project_id},
                                  {trains: taktarea.train.id},
                                  {taktareas: taktarea.id},
                                  {twaggons: waggon.id},
                                  {extendwp: ''},
                                  {showWithEntitiesNormalized: ''}
                                ],
                                u_object: {
                                  waggon_payload: {position: waggon_index + parseInt(2)},
                                  twp_id: $route.params.tworkpackage_id
                                },
                                reference: {
                                  before: false,
                                  type: 'twaggons',
                                  id: waggon.id
                                }
                              }).then((payload) => {
                                createUObject(payload)
                              })"
                            />
                          </template>
                          <template #badge>
                            <StandardDeleteButton
                              v-if="hover && isEditMode && $route.name === 'ProjectTaktPlan'"
                              :key="`waggonbadge${waggon.id}`"
                              direction="left"
                              @clickDelete="requestSnackbarDelete({
                                  url: [
                                    {projects: project_id},
                                    {trains: taktarea.train.id},
                                    {taktareas: taktarea.id},
                                    {twaggons: waggon.id}
                                  ],
                                }).then((payload) => {
                                  deleteUObject(payload)
                                })"
                            />
                          </template>
                          <template #content="{easter_egg}">
                            <StandardHover
                              v-if="(hover && $route.name === 'ProjectTaktPlan')"
                              :key="`waggonhover${waggon.id}`"
                              :easter_egg="easter_egg"
                              :class="easter_egg?'cursor-none':(isEditMode? 'cursor-grab':waggon.tworkpackages.length !== 0?'cursor-pointer':'cursor-default')"
                              @click.native="openWaggonInfo(waggon, taktarea.train.id, taktarea.id, waggon.id, $event)"
                            />
                            <div
                              v-if="$store.state.View.isMacroView" class="makro-view"
                              @click="openWaggonInfo(waggon, taktarea.train.id, taktarea.id, waggon.id, getUObjects({type: 'tworkpackages', ids: waggon.tworkpackages})[0])"
                              >
                              {{ waggon_index + 1}}
                            </div>
                            <draggable
                              class="display-flex flex-wrap"
                              :key="`workpackageswaggon${waggon.id}`"
                              :id="`workpackageswaggon${waggon.id}`"
                              :group="`workpackages_taktarea_${taktarea.id}`"
                              :component-data="getDraggableStyle()"
                              animation="300"
                              forceFallback="true"
                              fallbackOnBody="true"
                              :disabled="!hover || !isEditMode ||
                                         $route.name !== 'TaktPlanWorkPackageEdit'?
                                         true:false"
                              :value="waggon.tworkpackages"
                              @update="requestSnackbarUpdatePosition({
                                  url: [
                                    {projects: project_id},
                                    {trains: taktarea.train.id},
                                    {taktareas: taktarea.id},
                                    {twaggons: waggon.id},
                                    {tworkpackages: waggon.tworkpackages[$event.oldIndex]}
                                  ],
                                  update: {
                                    position: $event.newIndex - $event.oldIndex
                                  }
                                }).then((payload) => {
                                  updateUObjectPosition(payload)
                              })"
                              @start="draggable_old_twaggon_id = waggon.id"
                              @remove="requestSnackbarUpdateParent({
                                url: [
                                  {projects: project_id},
                                  {trains: taktarea.train.id},
                                  {taktareas: taktarea.id},
                                  {twaggons: waggon.id},
                                  {tworkpackages: waggon.tworkpackages[$event.oldIndex]},
                                  {updateparent: ''}
                                ],
                                update: {
                                  parent_id: parseInt($event.to.id.substring(18, $event.to.id.length)),
                                  position: $event.newIndex + parseInt(1),
                                }
                                }).then((payload) => {
                                    updateUObjectParent(payload)
                                  })
                              "
                              >
                              <v-hover
                                v-for="workpackage in getUObjects({type: 'tworkpackages', ids: waggon.tworkpackages})"
                                :key="`workpackage${workpackage.id}`"
                                >
                                <template #default="hover_workpackage">
                                  <Workpackage
                                    :workpackage_count="waggon.tworkpackages.length"
                                    :workpackage="workpackage"
                                    :easter_egg="easter_egg"
                                    :color="getStatisticSettings.filter &&
                                            (
                                            (getStatisticSettings.colors.length !== 0 &&
                                            !getStatisticSettings.colors.includes(workpackage.color)) ||
                                            (getStatisticSettings.icons.length !== 0 &&
                                            !getStatisticSettings.icons.includes(workpackage.icon)) ||
                                            (getStatisticSettings.status.length !== 0 &&
                                            !getStatisticSettings.status.includes(workpackage.status)) ||
                                            (getStatisticSettings.trains.length !== 0 &&
                                            !getStatisticSettings.trains.includes(taktarea.train.id))

                                          ) ||
                                          (isShowOwnWps &&
                                          getOwnTWorkPackages(project_id).length !== 0 &&
                                          !getOwnTWorkPackages(project_id).includes(workpackage.id))
                                          ?
                                          'grey darken-2':false"
                                    >
                                    <template #workpackage="workpackageslot">
                                      <StandardHover
                                        v-if="isTworkPackageHover(
                                          workpackage.id,
                                          workpackageslot.workpackage,
                                          hover_workpackage.hover,
                                          new_milestone.milestone)"
                                        :class="hover_workpackage.hover && $route.name === 'TaktPlanWorkPackageEdit'?'cursor-grab':'cursor-pointer'"
                                        :key="`workpackagehover${workpackage.id}`"
                                        @click.native="handleTWorkpackageClick(
                                          taktarea.train,
                                          waggon,
                                          workpackageslot.workpackage,
                                          taktarea.train.id,
                                          taktarea.id,
                                          waggon.id,
                                          workpackage.id,
                                          $event
                                          )"
                                        />
                                      <StandardBadge
                                        class="cursor-pointer"
                                        v-if="!hover &&
                                              workpackage.status &&
                                              (workpackage.status !== 'none' || workpackage.stop_status !== 'none') &&
                                              isShowStatusBadges &&
                                              workpackage.status !== 'stop'
                                              "
                                        :key="`workpackagebadge${workpackage.id}`"
                                        :icon="workpackage.stop_status !== 'none'?(workpackage.stop_status === 'ai_stop'?'ai_stop':'exclamation-triangle-negative'):getStatusArray.find(status => status.name === workpackage.status).icon"
                                        color="white"
                                        :content_color="workpackage.stop_status !== 'none' ? 'red':'black'"
                                        @click.native="$route.name === 'ProjectTaktPlan'?openWaggonInfo(waggon, taktarea.train.id, taktarea.id, waggon.id, $event):''"
                                      />
                                    </template>
                                  </Workpackage>
                                </template>
                              </v-hover>
                            </draggable>
                          </template>
                        </Waggon>
                      </template>
                    </v-hover>
                  </draggable>
                </div>
              </template>
            </v-hover>
          </template>
        </div>
        </div>
        <ProjectStructureTreeTaktplan
          v-else
          :parent="item"
          :open="!item.closed || (item.type === 'element_wrapper' && parent.element_wrappers_open.includes(item.id))?true:false"
          :child_elements="item.type === 'element_wrapper'?item.elements:getChildElements({parent_type: item.type, parent_id: item.id})"
          :key="`${item.type}${item.id}`"
          :sticky_left="sticky_left + 25"
          :project_length="project_length"
          :project_taktplan_spatial_header_width="project_taktplan_spatial_header_width"
          :project_id="project_id"
          :parent_color_index="parent_color_index + 1"
          :new_milestone="new_milestone"
          :milestone_selection="milestone_selection"
          :snackbar="snackbar"
          @parentClicked="$emit('parentClicked', $event)"
        />
      </template>
    </div>
    <div
      v-else
      class="project-structure-tree-taktplan-taktarea-wrapper"
      :style="`flex-shrink: 0; width: calc((${project_length + 1} * (var(--workpackage_width) + 8px) + var(--project_taktplan_ta_header_width) * 1px) * var(--taktplan_zoom));`"
      >
      <div
        v-if="getContainerTaktareas({project_id: project_id, parent_id: parent.id, parent_type: parent.type, element_ids: parent.type === 'element_wrapper'?parent.element_ids:false}).length === 0"
        class="project-structure-tree-taktplan-taktarea"
        >
        <HeaderPlaceholder
          width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
          height="calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom))"
          z_index="2"
          :sticky_left="`calc((var(--project_taktplan_spatial_header_width) * 1px) * var(--taktplan_zoom))`"
          :background_color="'var(--v-color-1-base)'"
          />
      </div>
      <v-hover
        v-for="taktarea in getContainerTaktareas({project_id: project_id, parent_id: parent.id, parent_type: parent.type, element_ids: parent.type === 'element_wrapper'?parent.element_ids:false})"
        :key="`taktarea${taktarea.id}`"
        >
        <template #default="hover_takarea">
          <div class="project-structure-tree-taktplan-taktarea">
            <HeaderRow
              z_index="2"
              sticky_left="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
              width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
              border_color="#424242"
              border_width="0px 0px 0px 0px"
              inner_border="solid 1px rgba(255,255,255,0.8)"
              :text="taktarea.name"
              :readonly="true"
            />
            <Placeholder
              :key="`placeholder_taktareastart_${taktarea.id}`"
              :count="taktarea.taktarea_start + taktarea.train.train_start"
              />
            <draggable
              class="display-flex"
              :key="`taktarewaggons${taktarea.id}`"
              animation="300"
              forceFallback="true"
              fallbackOnBody="true"
              :disabled="!hover_takarea.hover ||
                         !isEditMode ||
                         $route.name !=='ProjectTaktPlan'?
                         true:false"
              :value="taktarea.twaggons"
              @update="requestSnackbarUpdatePosition({
                  url: [
                    {projects: project_id},
                    {trains: taktarea.train.id},
                    {taktareas: taktarea.id},
                    {twaggons: taktarea.twaggons[$event.oldIndex]},
                  ],
                  update: {
                    position: $event.newIndex - $event.oldIndex,
                    position_twaggons: taktarea.twaggons
                  }
                }).then((payload) => {
                  updateUObjectPosition(payload)
              })"
              >
              <v-hover
                v-for="(waggon, waggon_index) in getUObjects({type: 'twaggons', ids: taktarea.twaggons})"
                :key="`waggonhoveractivtor${waggon.id}`"
                >
                <template #default="{hover}">
                    <Waggon
                      :key="`waggon${waggon.id}`"
                      :workpackage_count="waggon.tworkpackages.length"
                      :easter_egg="false"
                      >
                      <template #prepend
                        v-if="hover && isEditMode"
                        >
                        <Activator
                          :key="`waggonactivatorprepend${waggon.id}`"
                          v-if="$route.name === 'ProjectTaktPlan'"
                          class="self-centered cursor-cell"
                          @click.native="requestSnackbarCreate({
                            url: [
                              {projects: project_id},
                              {trains: taktarea.train.id},
                              {taktareas: taktarea.id},
                              {twaggons: ''},
                              {showWithEntitiesNormalized: ''}
                            ],
                            u_object: {
                              position: waggon_index + parseInt(1)
                            },
                            reference: {
                              before: true,
                              type: 'twaggons',
                              id: waggon.id
                            }
                          }).then((payload) => {
                            createUObject(payload)
                          })"
                        />
                        <Activator
                          :key="`waggonactivatorprepend${waggon.id}`"
                          v-if="$route.name === 'TaktPlanWorkPackageEdit' && waggon.tworkpackages.includes(parseInt($route.params.tworkpackage_id))"
                          class="self-centered cursor-cell"
                          @click.native="requestSnackbarCreate({
                            url: [
                              {projects: project_id},
                              {trains: taktarea.train.id},
                              {taktareas: taktarea.id},
                              {twaggons: waggon.id},
                              {extendwp: ''},
                              {showWithEntitiesNormalized: ''}
                            ],
                            u_object: {
                              waggon_payload: {position: waggon_index + parseInt(1)},
                              twp_id: $route.params.tworkpackage_id
                            },
                            reference: {
                              before: true,
                              type: 'twaggons',
                              id: waggon.id
                            }
                          }).then((payload) => {
                            createUObject(payload)
                          })"
                        />
                      </template>
                      <template #append
                        v-if="hover && isEditMode"
                        >
                        <Activator
                          :key="`waggonactivatorappend${waggon.id}`"
                          class="self-centered cursor-cell"
                          v-if="$route.name === 'ProjectTaktPlan'"
                          @click.native="requestSnackbarCreate({
                            url: [
                              {projects: project_id},
                              {trains: taktarea.train.id},
                              {taktareas: taktarea.id},
                              {twaggons: ''},
                              {showWithEntitiesNormalized: ''}
                            ],
                            u_object: {
                              position: waggon_index + parseInt(2)
                            },
                            reference: {
                              before: false,
                              type: 'twaggons',
                              id: waggon.id
                            }
                          }).then((payload) => {
                            createUObject(payload)
                          })"
                        />
                        <Activator
                          :key="`waggonactivatorappend${waggon.id}`"
                          class="self-centered cursor-cell"
                          v-if="$route.name === 'TaktPlanWorkPackageEdit' && waggon.tworkpackages.includes(parseInt($route.params.tworkpackage_id))"
                          @click.native="requestSnackbarCreate({
                            url: [
                              {projects: project_id},
                              {trains: taktarea.train.id},
                              {taktareas: taktarea.id},
                              {twaggons: waggon.id},
                              {extendwp: ''},
                              {showWithEntitiesNormalized: ''}
                            ],
                            u_object: {
                              waggon_payload: {position: waggon_index + parseInt(2)},
                              twp_id: $route.params.tworkpackage_id
                            },
                            reference: {
                              before: false,
                              type: 'twaggons',
                              id: waggon.id
                            }
                          }).then((payload) => {
                            createUObject(payload)
                          })"
                        />
                      </template>
                      <template #badge>
                        <StandardDeleteButton
                          v-if="hover && isEditMode && $route.name === 'ProjectTaktPlan'"
                          :key="`waggonbadge${waggon.id}`"
                          direction="left"
                          @clickDelete="requestSnackbarDelete({
                              url: [
                                {projects: project_id},
                                {trains: taktarea.train.id},
                                {taktareas: taktarea.id},
                                {twaggons: waggon.id}
                              ],
                            }).then((payload) => {
                              deleteUObject(payload)
                            })"
                        />
                      </template>
                      <!-- :easter_egg="waggon.tworkpackages[0] % 10 === 0 && hover" -->
                      <template #content="{easter_egg}">
                        <StandardHover
                          v-if="(hover && $route.name === 'ProjectTaktPlan')"
                          :key="`waggonhover${waggon.id}`"
                          :easter_egg="easter_egg"
                          :class="easter_egg?'cursor-none':(isEditMode? 'cursor-grab':waggon.tworkpackages.length !== 0?'cursor-pointer':'cursor-default')"
                          @click.native="openWaggonInfo(waggon, taktarea.train.id, taktarea.id, waggon.id, $event)"
                        />
                        <div
                          v-if="$store.state.View.isMacroView" class="makro-view"
                          @click="openWaggonInfo(waggon, taktarea.train.id, taktarea.id, waggon.id, getUObjects({type: 'tworkpackages', ids: waggon.tworkpackages})[0])"
                          >
                          {{ waggon_index + 1}}
                        </div>
                        <draggable
                          class="display-flex flex-wrap"
                          :key="`workpackageswaggon${waggon.id}`"
                          :id="`workpackageswaggon${waggon.id}`"
                          :group="`workpackages_taktarea_${taktarea.id}`"
                          :component-data="getDraggableStyle()"
                          animation="300"
                          forceFallback="true"
                          fallbackOnBody="true"
                          :disabled="!hover || !isEditMode ||
                                     $route.name !== 'TaktPlanWorkPackageEdit'?
                                     true:false"
                          :value="waggon.tworkpackages"
                          @update="requestSnackbarUpdatePosition({
                              url: [
                                {projects: project_id},
                                {trains: taktarea.train.id},
                                {taktareas: taktarea.id},
                                {twaggons: waggon.id},
                                {tworkpackages: waggon.tworkpackages[$event.oldIndex]}
                              ],
                              update: {
                                position: $event.newIndex - $event.oldIndex
                              }
                            }).then((payload) => {
                              updateUObjectPosition(payload)
                          })"
                          @start="draggable_old_twaggon_id = waggon.id"
                          @remove="requestSnackbarUpdateParent({
                            url: [
                              {projects: project_id},
                              {trains: taktarea.train.id},
                              {taktareas: taktarea.id},
                              {twaggons: waggon.id},
                              {tworkpackages: waggon.tworkpackages[$event.oldIndex]},
                              {updateparent: ''}
                            ],
                            update: {
                              parent_id: parseInt($event.to.id.substring(18, $event.to.id.length)),
                              position: $event.newIndex + parseInt(1),
                            }
                            }).then((payload) => {
                                updateUObjectParent(payload)
                              })
                          "
                          >
                          <v-hover
                            v-for="workpackage in getUObjects({type: 'tworkpackages', ids: waggon.tworkpackages})"
                            :key="`workpackage${workpackage.id}`"
                            >
                            <template #default="hover_workpackage">
                              <Workpackage
                                :workpackage_count="waggon.tworkpackages.length"
                                :workpackage="workpackage"
                                :easter_egg="easter_egg"
                                :color="getStatisticSettings.filter &&
                                        (
                                        (getStatisticSettings.colors.length !== 0 &&
                                        !getStatisticSettings.colors.includes(workpackage.color)) ||
                                        (getStatisticSettings.icons.length !== 0 &&
                                        !getStatisticSettings.icons.includes(workpackage.icon)) ||
                                        (getStatisticSettings.status.length !== 0 &&
                                        !getStatisticSettings.status.includes(workpackage.status)) ||
                                        (getStatisticSettings.trains.length !== 0 &&
                                        !getStatisticSettings.trains.includes(taktarea.train.id))

                                      ) ||
                                      (isShowOwnWps &&
                                      getOwnTWorkPackages(project_id).length !== 0 &&
                                      !getOwnTWorkPackages(project_id).includes(workpackage.id))
                                      ?
                                      'grey darken-2':false"
                                >
                                <template #workpackage="workpackageslot">
                                  <StandardHover
                                    v-if="isTworkPackageHover(
                                      workpackage.id,
                                      workpackageslot.workpackage,
                                      hover_workpackage.hover,
                                      new_milestone.milestone)"
                                    :class="hover_workpackage.hover && $route.name === 'TaktPlanWorkPackageEdit'?'cursor-grab':'cursor-pointer'"
                                    :key="`workpackagehover${workpackage.id}`"
                                    @click.native="handleTWorkpackageClick(
                                      taktarea.train,
                                      waggon,
                                      workpackageslot.workpackage,
                                      taktarea.train.id,
                                      taktarea.id,
                                      waggon.id,
                                      workpackage.id,
                                      $event
                                      )"
                                    />
                                  <StandardBadge
                                    class="cursor-pointer"
                                    v-if="!hover &&
                                          workpackage.status &&
                                          (workpackage.status !== 'none' || workpackage.stop_status !== 'none') &&
                                          isShowStatusBadges &&
                                          workpackage.status !== 'stop'
                                          "
                                    :key="`workpackagebadge${workpackage.id}`"
                                    :icon="workpackage.stop_status !== 'none'?(workpackage.stop_status === 'ai_stop'?'ai_stop':'exclamation-triangle-negative'):getStatusArray.find(status => status.name === workpackage.status).icon"
                                    color="white"
                                    :content_color="workpackage.stop_status !== 'none' ? 'red':'black'"
                                    @click.native="$route.name === 'ProjectTaktPlan'?openWaggonInfo(waggon, taktarea.train.id, taktarea.id, waggon.id, $event):''"
                                  />
                                </template>
                              </Workpackage>
                            </template>
                          </v-hover>
                        </draggable>
                      </template>
                    </Waggon>
                </template>
              </v-hover>
            </draggable>
          </div>
        </template>
      </v-hover>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import draggable from "vuedraggable";

  import ProjectStructureTreeTaktplan from '@/components/ProjectStructure/ProjectStructureTreeTaktplan.component.vue'
  import Waggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
  import Workpackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
  import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue';
  import StandardHover from '@/components/StandardComponents/StandardHover.component.vue';
  import Placeholder from '@/components/ProjectTaktPlan/Placeholder.component.vue';
  import HeaderRow from '@/components/ProjectTaktPlan/HeaderRow.component.vue';
  import HeaderPlaceholder from '@/components/ProjectTaktPlan/HeaderPlaceholder.component.vue';
  import Activator from '@/components/ProjectTaktPlan/Activator.component.vue'
  import StandardDeleteButton from '@/components/StandardComponents/StandardDeleteButton.component.vue'

  import { TWaggonMixin } from '@/mixins/TWaggon.mixin.js'

  export default {
    props: [
      'parent',
      'open',
      'child_elements',
      'sticky_left',
      'project_length',
      'project_id',
      'project_taktplan_spatial_header_width',
      'parent_color_index',
      'new_milestone',
      'milestone_selection',
      'snackbar'
    ],
    name: 'ProjectStructureTreeTaktplan',
    mixins: [
      TWaggonMixin,
    ],
    components: {
      draggable,
      ProjectStructureTreeTaktplan,
      Waggon,
      Workpackage,
      StandardBadge,
      StandardHover,
      Placeholder,
      HeaderRow,
      HeaderPlaceholder,
      StandardDeleteButton,
      Activator
    },
    data: () => ({
    }),
    computed: {
      ...mapGetters('Project', [
        'isEditMode',
      ]),
      ...mapGetters('ProjectStructure', [
        'getChildElements',
        'getElementTaktareas',
        'getContainerTaktareas',
      ]),
      ...mapGetters('Ultra', [
        'getUObjects',
      ]),
      ...mapGetters('ProjectStatistics', [
        'getStatisticSettings',
      ]),
      ...mapGetters('Project', [
        'getOwnTWorkPackages',
        'isShowStatusBadges',
        'getStatusArray',
      ]),
      ...mapGetters('View', [
          'isShowOwnWps',
      ]),
      ...mapGetters('ProjectMilestone', [
        'getNewMilestone',
        'getMileStoneLinkType',
      ]),
    },
    methods: {
      ...mapActions('Ultra', [
          'createUObject',
          'updateUObjectPosition',
          'updateUObjectParent',
          'deleteUObject',
        ]),
      ...mapActions('SnackBar', [
        'requestSnackbarCreate',
        'requestSnackbarUpdatePosition',
        'requestSnackbarUpdateParent',
        'requestSnackbarDelete',
      ]),
      ...mapActions('ProjectMilestone', [
        'updateMilestoneBulk',
        'updateNewMilestoneBulk',
        'resetNewMilestone',
        'editMilestoneSelection',
        'editNewMilestoneSelection',
      ]),
      getDraggableStyle(){
        return {attrs: {'style': `width: calc((var(--workpackage_width) + 4px) * var(--taktplan_zoom)); height: calc((var(--workpackage_height) + 4px) * var(--taktplan_zoom))`}};
      },
      handleTWorkpackageClick(train, waggon, work_package, train_id, taktarea_id, waggon_id, workpackage_id, evt) {
        if (this.$route.name === 'TrainMilestonesAdd' &&
          this.getNewMilestone(this.project_id).milestone.linkType === 'selection') {
          this.editNewMilestoneSelection({
            project_id: this.project_id,
            prop: 'tworkpackages',
            value: work_package,
            train: train,
          });
        }
        else if (this.$route.name === 'TrainMilestonesAdd' &&
          this.getNewMilestone(this.project_id).milestone.linkType === 'type') {
          this.updateNewMilestoneBulk([
            {prop: 'wp_color_active', value: true},
            {prop: 'wp_color', value: work_package.color},
            {prop: 'wp_token_active', value: true},
            {prop: 'wp_token', value: work_package.token},
            {prop: 'wp_icon_active', value: true},
            {prop: 'wp_icon', value: work_package.icon},
            {prop: 'wp_name_active', value: true},
            {prop: 'wp_name', value: work_package.name},
          ]);
        }
        else if (this.$route.name === 'TrainMilestonesEdit' &&
            this.getMileStoneLinkType({
              project_id: this.project_id,
              milestone_id: this.$route.params.milestone_id
            }) === 'selection') {
          this.editMilestoneSelection({
            project_id: this.project_id,
            milestone_id: this.$route.params.milestone_id,
            prop: 'tworkpackages',
            value: work_package,
            train: train,
          });
        }
        else if (this.$route.name === 'TrainMilestonesEdit' &&
            this.getMileStoneLinkType({
              project_id: this.project_id,
              milestone_id: this.$route.params.milestone_id
            }) === 'type') {
          this.updateMilestoneBulk({
            project_id: this.project_id,
            milestone_id: this.$route.params.milestone_id,
            type: 'milestones',
            data: [
              {prop: 'wp_color_active', value: true},
              {prop: 'wp_color', value: work_package.color},
              {prop: 'wp_token_active', value: true},
              {prop: 'wp_token', value: work_package.token},
              {prop: 'wp_icon_active', value: true},
              {prop: 'wp_icon', value: work_package.icon},
              {prop: 'wp_name_active', value: true},
              {prop: 'wp_name', value: work_package.name},
            ]
          });
        }
        else {
          // this.$emit('openWaggonInfo', evt)
          this.openWaggonInfo(waggon, train_id, taktarea_id, waggon_id, evt, workpackage_id)
        }
      },
      isTworkPackageHover(workpackage_id, workpackage, hover, new_milestone) {
        if (hover && this.$route.name !== 'ProjectTaktPlan') {
          return true;
        }
        else if (new_milestone.tworkpackages.indexOf(workpackage_id) !== -1 &&
            this.$route.name === 'TrainMilestonesAdd' && new_milestone.linkType === 'selection'
          ) {
          return true;
        }
        else if (new_milestone.linkType === 'type' &&
          ((new_milestone.wp_color_active && new_milestone.wp_color === workpackage.color) || !new_milestone.wp_color_active) &&
          ((new_milestone.wp_token_active && new_milestone.wp_token === workpackage.token) || !new_milestone.wp_token_active) &&
          ((new_milestone.wp_icon_active && new_milestone.wp_icon === workpackage.icon) || !new_milestone.wp_icon_active) &&
          ((new_milestone.wp_name_active && new_milestone.wp_name === workpackage.name) || !new_milestone.wp_name_active) &&
          !(!new_milestone.wp_color_active && !new_milestone.wp_token_active && !new_milestone.wp_icon_active && !new_milestone.wp_name_active) &&
          this.$route.name === 'TrainMilestonesAdd'
        ) {
          return true;
        }
        else if (this.milestone_selection.tworkpackages.includes(workpackage_id) &&
          ['TrainMilestonesDetails', 'TrainMilestonesEdit'].includes(this.$route.name)
        ) {
          return true;
        }
        else if (this.snackbar && this.snackbar.show && this.snackbar.hover) {
          if (this.snackbar.action !== 'updateparent' && this.snackbar.target_type === 'tworkpackages' && this.getAffectedTargets.includes(workpackage_id)) {
            return true;
          }
          else if (this.snackbar.target_type.substring(this.snackbar.target_type.length-5) === 'steps' && this.snackbar.affected_parents.includes(workpackage_id)) {
            return true;
          }
          else {
            return false;
          }
        } else {
          return false;
        }
      }
    }
  }
</script>
<style>
  .project-structure-tree-taktplan {
    display: flex;
    user-select: none;
    flex-shrink: 0;
    font-size: calc(16px * var(--taktplan_zoom));
  }
  .project-structure-tree-taktplan-parent {
    position: sticky;
    flex-shrink: 0;
    /* color: var(--header_border_color); */
    /* line-height: 25px; */
    z-index: 2;
    border-style: solid;
    /* border-color: var(--header_border_color);
    border-width: 1px; */
    /* background-color: rgba(255,255,255,1); */
    will-change: width;
    cursor: pointer;
    overflow: hidden;
  }
  .project-structure-tree-taktplan-parent-open {
    border-width: 0px 0px 1px 1px;

    /* width: 25px; */
    writing-mode: vertical-lr;
    text-orientation: mixed;
    transform: rotate(180deg);
    text-align: center;
    overflow: hidden;
    padding-bottom: 6px;
    text-overflow: clip;
    /* position: relative; */
  }
  .project-structure-tree-taktplan-parent-closed {
    border-width: 1px 1px 0px 0px;

    /* width: calc(100% + 25px); */
    /* width: 200px; */
    /* height: 25px; */
    min-height: 25px;
    overflow: hidden;
    padding-left: 6px;
  }
  .project-structure-tree-taktplan-children {
    /* width: 100%; */
    flex-shrink: 0;
  }
  .project-structure-tree-taktplan-element {
    position: sticky;
    /* position: relative; */
    display: flex;
    /* height: 42px; */
    width: 200px;
    flex-shrink: 0;
    align-items: center;
    justify-content: flex-end;
    padding-right: 6px;
    overflow: hidden;
    background-color: var(--v-color-4-base);
    border-style: solid;
    border-color: var(--header_border_color);
    border-width: 0px 0px 1px 0px;
    z-index: 2;
    will-change: width;
  }
  .project-structure-tree-taktplan-taktarea-wrapper {
    border-bottom: solid 1px #424242;

  }
  .project-structure-tree-taktplan-taktarea {
    display: flex;
    height: calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom));
    align-items: center;
  }
  .makro-view {
    height: 100%;
    width: 100%;
    background-color: rgb(138 138 138 / 50%);
    position: absolute;
    z-index: 2;
    text-align: center;
    cursor: pointer;
    padding-top: 7px;
    color: white !important;
  }
</style>
